import React from "react";
import NumberFormat from "react-number-format";

import "../App.css";

const Pedido = (props) => {
  return (
    <div
      className="pedido"
      onClick={props.persona || props.n_total > 39 ? props.terminar : ""}
      style={{ display: props.n_total > 0 ? "flex" : "none" }}
    >
      <div className="info_pedido">
        <p>Snacks</p>
        <b>
          <NumberFormat
            value={props.n_total}
            displayType={"text"}
            className="details"
          />
        </b>
      </div>
      <div className="info_pedido">
        <p>Total</p>
        <b>
          <NumberFormat
            value={props.price_total}
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            prefix={"$"}
            className="details"
          />
        </b>
      </div>

      <div className="info_button">
        <p className="button_a">{props.persona || props.n_total > 39 ? "Continuar" : "Min 40 un."}</p>
      </div>
    </div>
  );
};

export default Pedido;
